module.exports = __webpack_public_path__ + "img/bg_faq.824b0603.png";